module.exports = __webpack_public_path__ + "media/Components/Logos/icon-tool-toleft-eb6d691d6153ea210fd0d7b963e474df.svg";